import { PlanName } from 'types/globalState';

/**
 *
 * @param planName - The name of the current plan
 *
 * @description Get the allowed date filter range based on the plan.
 * Date range will be restricted from current day
 * - in case of 1 month - 31 days from current day
 * - in case of 1 year - 365 days from current day
 * - in case of 3 year - 1095 days from current day
 *
 * @returns The number of days allowed for the date filter range
 */
const getDateFilterRangeBasedOnPlan = (planName: PlanName): number => {
  switch (planName) {
    case PlanName.ESSENTIAL:
    case PlanName.BASIC:
      return 31; // 1 month
    case PlanName.PREMIUM:
      return 365; // 1 year
    case PlanName.UNLIMITED:
      return 1095; // 3 years
    default:
      return 31; // Default to 1 month
  }
};

export default getDateFilterRangeBasedOnPlan;
